'use strict';

import React from 'react';
import { Box, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import { Brand } from '@/lenses/uilenses/theme/colors';
import { useAuth } from '@/hooks/auth.hook.js';
import StudyBuilderPage from './StudyBuilderPage.jsx';

/**
 * Study builder reachable without portal login. Auth is required only when revealing the estimate (handled in QuoteWizard).
 * Intentionally no header "Sign in" link — guests use "See your estimate" or the public landing to reach login.
 */
export function PublicStudyBuilderLayout() {
	const auth = useAuth();
	const authenticated = auth.isAuthenticated();
	const exitHomePath = authenticated ? '/home' : '/';

	return (
		<Box sx={{ minHeight: '100vh', background: Brand.metaboliteWhite }}>
			<Box
				sx={{
					px: 2,
					py: 1.5,
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'center',
					gap: 2,
					borderBottom: `1px solid ${Brand.precisionGrey}`,
					background: Brand.pureWhite,
				}}
			>
				{authenticated ? (
					<MuiLink
						component={Link}
						to="/home"
						target="_blank"
						rel="noopener noreferrer"
						sx={{ fontWeight: 600 }}
					>
						My projects
					</MuiLink>
				) : null}
			</Box>
			<StudyBuilderPage exitHomePath={exitHomePath} enableGuestSessionPersistence />
		</Box>
	);
}
